import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Feedback
 *
 */

const Reports = lazyLoad(
  () => import('app/modules/Reports'),
  (module) => module.default,
);

export default Reports;
